function areArraysEqual(array1, array2, itemComparer = (a, b) => a === b) {
  return array1.length === array2.length && array1.every((value, index) => itemComparer(value, array2[index]));
}
export default areArraysEqual;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/areArraysEqual.js
// module id = 1812
// module chunks = 22